import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbNavigation = ({ className = '' }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const routeMap = {
    '/provider-dashboard': { label: 'داشبورد', icon: 'LayoutDashboard' },
    '/provider-management': { label: 'مدیریت تیم', icon: 'Store' },
    '/employee-management': {
      label: 'مدیریت کارکنان',
      icon: 'Users',
      parent: '/provider-management',
    },
    '/service-management': {
      label: 'مدیریت خدمات',
      icon: 'Scissors',
      parent: '/provider-management',
    },
    '/availability-calendar': {
      label: 'تقویم دسترسی',
      icon: 'Calendar',
      parent: '/provider-management',
    },
    '/user-profile': { label: 'پروفایل کاربری', icon: 'User' },
  };

  const generateBreadcrumbs = () => {
    const currentRoute = routeMap?.[location?.pathname];
    if (!currentRoute) return [];

    const breadcrumbs = [];

    // Add parent if exists
    if (currentRoute?.parent) {
      const parentRoute = routeMap?.[currentRoute?.parent];
      if (parentRoute) {
        breadcrumbs?.push({
          label: parentRoute?.label,
          path: currentRoute?.parent,
          icon: parentRoute?.icon,
          isActive: false,
        });
      }
    }

    // Add current route
    breadcrumbs?.push({
      label: currentRoute?.label,
      path: location?.pathname,
      icon: currentRoute?.icon,
      isActive: true,
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs?.length <= 1) {
    return null;
  }

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <nav
      className={`flex items-center bg-grey-400 gap-2 text-sm ${className}`}
      aria-label="Breadcrumb">
      <div className="flex items-center gap-2">
        <Icon name="Home" size={16} className="text-muted-foreground" />
        <button
          onClick={() => handleNavigation('/provider-dashboard')}
          className="text-muted-foreground hover:text-foreground transition-colors duration-150">
          خانه
        </button>
      </div>
      {breadcrumbs?.map((crumb, index) => (
        <div key={crumb?.path} className="flex items-center gap-2">
          <Icon
            name="ChevronLeft"
            size={14}
            className="text-muted-foreground rotate-180"
          />

          {crumb?.isActive ? (
            <div className="flex items-center gap-2">
              <Icon name={crumb?.icon} size={16} className="text-primary" />
              <span className="text-foreground font-medium">
                {crumb?.label}
              </span>
            </div>
          ) : (
            <button
              onClick={() => handleNavigation(crumb?.path)}
              className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors duration-150">
              <Icon name={crumb?.icon} size={16} />
              <span>{crumb?.label}</span>
            </button>
          )}
        </div>
      ))}
    </nav>
  );
};

export default BreadcrumbNavigation;
